// AUTO-GENERATED by scripts/build-registry.js: study entry for air-law/operate-equipment-standard.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/air-law/operate-equipment-standard/operate-equipment-standard.js';

mount([g0]);
